import {
    deleteRouteCostLoading,
    deleteRouteCostRequest,
    deleteRouteCostSuccess,
    deleteRouteCostReject,
    deleteRouteCostReset,
} from "../../actions/route/deleteCost";

export const deleteRouteCost = (formData) => async (dispatch, getState) => {
    dispatch(deleteRouteCostLoading());
    try {
        const { data } = await deleteRouteCostRequest(formData, getState);
        dispatch(deleteRouteCostSuccess(data))
    } catch (error) {
        dispatch(deleteRouteCostReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteRouteCostReset()) }, 3000);
    }
    return Promise.resolve();
};